import { usePageDrawer } from '@app/components/page/drawer/PageDrawerContext';
import { usePostHogCapture } from '@app/core/integrations/posthog/usePostHogCapture';
import SaveIcon from '@mui/icons-material/Save';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useFragmentEditorStore } from '../../stores/useFragmentEditorStore';

export function CreateJointFragmentBtn() {
  const { openDrawer } = usePageDrawer();
  const fragment = useFragmentEditorStore((state) => state.fragment);
  const capture = usePostHogCapture({ domain: 'create_fragment' });

  const handleSave = () => {
    if (!fragment) return;

    capture('open_joint_create', { chunk_count: fragment.chunks.length });
    openDrawer('create-joint-fragment');
  };

  return (
    <Button
      data-testid="joint-fragment-save"
      variant="outlined"
      startIcon={<SaveIcon />}
      onClick={handleSave}
    >
      <FormattedMessage
        id="jointFragments.editorScreen.toolbar.create"
        defaultMessage="Crear fragmento"
      />
    </Button>
  );
}
